import _ from 'lodash';
import React from 'react';
import classnames from 'classnames';

interface ISelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  blurOnChange?: boolean;
  fullWidth?: boolean;
  size?: 'md' | 'sm';
}

/** @deprecated - prefer @design-system/Autocomplete` */
class Select extends React.Component<ISelectProps> {
  private selectRef: React.RefObject<HTMLSelectElement>;

  static defaultProps = {
    size: 'md',
    fullWidth: false,
  };

  constructor(props: ISelectProps) {
    super(props);

    this.selectRef = React.createRef();
  }

  onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (this.props.onChange) {
      this.props.onChange(e);

      if (this.props.blurOnChange) {
        this.selectRef.current!.blur();
      }
    }
  };

  render() {
    const propsToForward = _.omit(
      this.props,
      'onChange',
      'blurOnChange',
      'fullWidth',
      'size',
      'className',
    );

    return (
      <div
        className={classnames('wrapper', this.props.size, this.props.className, {
          full: !!this.props.fullWidth,
        })}
      >
        <select ref={this.selectRef} onChange={this.onChange} {...propsToForward}>
          {this.props.children}
        </select>

        <style jsx>{`
          select {
            background-color: #f5f4f9;
            border-radius: var(--border-radius);
            font-size: 14px;
            font-family: var(--font-family);
            appearance: none;
            border: 0;
            padding-right: 28px;
            cursor: pointer;
            height: 26px;
            color: var(--color-form-input);
          }
          select:disabled {
            color: #999;
            pointer-events: none;
          }

          .wrapper {
            display: inline-block;
            border-radius: 8px;
            position: relative;

            flex-shrink: 1;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .wrapper::before {
            position: absolute;
            border: 4px solid transparent;
            border-bottom: 4px solid #636e7d;
            content: ' ';
            display: block;
          }

          .wrapper::after {
            position: absolute;
            border: 4px solid transparent;
            border-top: 4px solid #636e7d;
            content: ' ';
            display: block;
          }

          .full {
            width: 100%;
          }

          .full select {
            width: 100%;
          }

          .md select {
            height: 30px;
            padding: 0 28px 0 10px;
          }

          .md::before {
            right: 10px;
            top: 4px;
          }

          .md::after {
            right: 10px;
            bottom: 4px;
          }

          .sm select {
            height: 24px;
            padding: 0 20px 0 6px;
          }

          .sm::before {
            right: 6px;
            top: 2px;
          }

          .sm::after {
            right: 6px;
            bottom: 2px;
          }
        `}</style>
      </div>
    );
  }
}

export default Select;
